import React, { useEffect } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { locationsActions } from '../../behavior/locations';
import { Label } from 'semantic-ui-react';

const BBuildingDetailsContainer = ({ values }) => {

  const { locationAisPubDetails } = values;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const buildingSummaryLocationId = useSelector(state => state?.locations?.summary?.buildingSummary?.location?.id);
  const watercourseName = useSelector(state => state?.locations?.watershed?.watercourse);

  useEffect(() => {
    dispatch(locationsActions.getWatershedByLocation(buildingSummaryLocationId));
  }, [buildingSummaryLocationId]);

  let locationDetails = [];

  function addParameterLabelToDetails(keyText, parameterText) {
    if (parameterText) {
      locationDetails.push(
        <>
          <b>
            {t(keyText)}
          </b>
          <Label color="blue" mini basic>
            {parameterText}
          </Label>
        </>
      );
    }
  }

  addParameterLabelToDetails('building.summary.page.description.label', locationAisPubDetails.description);
  addParameterLabelToDetails('building.summary.page.surface.label', locationAisPubDetails.surface);
  addParameterLabelToDetails('building.summary.page.site.label', locationAisPubDetails.site);
  addParameterLabelToDetails('building.summary.page.commune.label', locationAisPubDetails.commune);
  addParameterLabelToDetails('building.summary.page.department.label', locationAisPubDetails.department);
  addParameterLabelToDetails('building.summary.page.watercourse.label', watercourseName);

  return (
    <>
      {locationDetails}
    </>
  );
};

export default withTranslation()(BBuildingDetailsContainer);
